// 积分相关翻译

export const credits = {
    availableCredits: '可用积分',
    creditsUsed: '已使用积分',
    totalCredits: '总积分',
    buyCredits: '购买积分',
    freeCredits: '免费积分',
    paidCredits: '付费积分',
    credits: '积分',
    remainingCredits: '剩余积分',
    recharge: '充值',
    transactionHistory: '交易记录',
    transactionNo: '交易编号',
    amount: '金额',
    transactionTime: '交易时间',
    noTransactionRecords: '暂无交易记录',
    transactionType: {
      title: '交易类型',
      earned: '获得',
      spent: '消费',
      refunded: '退款',
      catooGenerate: 'Catoo生成',
      newUserReward: '新用户奖励'
    }
  };
